import { Component, OnInit } from '@angular/core'
import { MdDialogRef } from '@angular/material'

@Component({
  selector: 'cm-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.css']
})
export class ConfirmDialogComponent implements OnInit {

  public title: string
  public message: string

  constructor(private dialogRef: MdDialogRef<ConfirmDialogComponent>) { }

  ngOnInit() {
  }

  ok() {
    this.dialogRef.close(true)
  }

  cancel() {
    this.dialogRef.close(false)
  }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/dialog/confirm-dialog/confirm-dialog.component.ts